var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexDownFade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 72,
    viewBox: "0 0 62 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9795 72L62 54V18L30.9795 0L0 18V54L30.9795 72Z",
    fill: "url(#paint0_linear_280_6110)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_6110",
    x1: 29.9491,
    y1: 48.5,
    x2: 25.6617,
    y2: 3.38547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13131B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13131B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexDownFade);
export default __webpack_public_path__ + "static/media/hexDownFade.eb3a5fd325a412ddaffacc9d6f9f0c39.svg";
export { ForwardRef as ReactComponent };